import { useWizardNavigation } from './use-wizard';
import { StepContainer } from './step-container';
import { Check } from 'lucide-react';
import type { Category } from '@repo/shared-types';

function StepCategory() {
  const {
    searchParams,
    goNext,
    goBack,
    currentIndex,
    totalSteps,
    tournament,
  } = useWizardNavigation();
  const currentCategory = searchParams.get('categoria') || '';

  const handleSelect = (categoryId: string) => {
    goNext({ categoria: categoryId });
  };

  return (
    <StepContainer
      stepIndex={currentIndex}
      totalSteps={totalSteps}
      title="¿En qué categoría van a participar?"
      description="Tocá la categoría para continuar."
      onBack={goBack}
      showNext={false}
    >
      <div className="grid grid-cols-1 gap-3">
        {tournament.categories.map((category: Category) => {
          const isSelected = currentCategory === category.id.toString();
          return (
            <button
              key={category.id}
              type="button"
              onClick={() => handleSelect(category.id.toString())}
              className={`w-full text-left p-5 rounded-xl border-2 transition-all active:scale-[0.98] ${
                isSelected
                  ? 'border-primary bg-primary/5 ring-4 ring-primary/10'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-lg font-semibold text-gray-900">
                  {category.name}
                </span>
                {isSelected && (
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                )}
              </div>
              {category.description && (
                <p className="text-sm text-gray-500 mt-1">
                  {category.description}
                </p>
              )}
              {category.tagList?.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mt-2">
                  {category.tagList.map((tag: string) => (
                    <span
                      key={tag}
                      className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </StepContainer>
  );
}

export const route = {
  path: 'categoria',
  element: <StepCategory />,
};
